export const SETTING = {
	SET_PROFILE : 'SET_PROFILE',
	TOGGLE_AUTH_IN_PROGRESS : 'TOGGLE_AUTH_IN_PROGRESS',
};

export const ERROR = {
	SET_ERROR : 'SET_ERROR',
	UNSET_ERROR : 'UNSET_ERROR'
};

export const PATIENTS = {
	SET_ACTIVE_CALL_DATA : 'SET_ACTIVE_CALL_DATA',
	UNSET_ACTIVE_CALL_DATA : 'UNSET_ACTIVE_CALL_DATA',
	SET_PARTICIPANTS: 'SET_PARTICIPANTS'
};

export const PARTICIPANTS = {
	SET_PARTICIPANTS: 'SET_PARTICIPANTS'
};

export const ROOM = {
	SET_ACTIVE_ROOM_DATA : 'SET_ACTIVE_ROOM_DATA',
	UNSET_ACTIVE_ROOM_DATA : 'UNSET_ACTIVE_ROOM_DATA'
};

export const THERAPISTS = {
	SET_ACTIVE_CALL_DATA : 'SET_ACTIVE_CALL_DATA',
	UNSET_ACTIVE_CALL_DATA : 'UNSET_ACTIVE_CALL_DATA',
	SET_CURRENT_ACTIVE_CALL : 'SET_CURRENT_ACTIVE_CALL',
	UNSET_CURRENT_ACTIVE_CALL : 'UNSET_CURRENT_ACTIVE_CALL',
	SET_CALL_HISTORY : 'SET_CALL_HISTORY',
	UNSET_CALL_HISTORY : 'UNSET_CALL_HISTORY',
	SET_ACTIVE_CALL_HISTORY : 'SET_ACTIVE_CALL_HISTORY',
	UNSET_ACTIVE_CALL_HISTORY : 'UNSET_ACTIVE_CALL_HISTORY',
	UNSET_ACTIVE_CALL_HISTORY_FLAG : 'UNSET_ACTIVE_CALL_HISTORY_FLAG',
	SET_PATIENT_VISITS : 'SET_PATIENT_VISITS',
	UNSET_PATIENT_VISITS : 'UNSET_PATIENT_VISITS',
	FETCH_GROUP_CALL_HISTORY : 'FETCH_GROUP_CALL_HISTORY',
	SET_GROUP_CALL_HISTORY : 'SET_GROUP_CALL_HISTORY',
	UNSET_GROUP_CALL_HISTORY : 'UNSET_GROUP_CALL_HISTORY',
};

export const USER = {
	SET_USER_DATA : 'SET_USER_DATA',
	SET_USER_CONFIRMATION : 'SET_USER_CONFIRMATION',
	SET_USER_ROLE : 'SET_USER_ROLE',
	UNSET_USER_DATA : 'UNSET_USER_DATA',
	UNSET_USER_ROLE : 'UNSET_USER_ROLE',
	SET_USER_STATUS: 'SET_USER_STATUS',
	UNSET_USER_STATUS: 'UNSET_USER_STATUS'
};

export const CONTACTS = {
	APPEND_MY_CONTACT_LIST : 'APPEND_MY_CONTACT_LIST'
};

export const MESSAGES  = { 
	SET_MESSAGE_LIST: 'SET_MESSAGE_LIST',
	SET_CHAT_LIST: 'SET_CHAT_LIST',
	APPEND_MESSAGE_LIST : 'APPEND_MESSAGE_LIST',
	SET_USER_ACCESS: 'SET_USER_ACCESS',
	UPDATE_MESSAGE_LIST_READ_RECEIPT: 'UPDATE_MESSAGE_LIST_READ_RECEIPT',
	APPEND_SINGLE_MESSAGE : 'APPEND_SINGLE_MESSAGE',
	DELETE_MESSAGE : 'DELETE_MESSAGE',
	UNSET_MESSAGE_LIST : 'UNSET_MESSAGE_LIST',
	UPDATE_OG_DATA : 'UPDATE_OG_DATA',
}